import { authenticatedFetch } from "./http";

export interface WorkflowStepDiagnostic {
  id: string;
  validationLevel: number;
  businessPartnerCode: string;
  businessPartnerName: string;
  businessPartnerKind: string;
  status: string;
  allowProposalAdjustment: boolean;
  directApplication: boolean;
  availableActions: Array<{ code: string; transition: string; outcome: string }>;
  selectedAction: string | null;
  proposedPayload: Record<string, unknown>;
  decidedPayload: Record<string, unknown> | null;
  decisionComment: string | null;
  decidedBy: string | null;
  decidedAt: string | null;
}

export interface WorkflowDiagnostic {
  id: string;
  messageType: string;
  subjectType: string;
  subjectId: string;
  subjectReference: string | null;
  state: string;
  currentValidationLevel: number | null;
  currentBusinessPartnerName: string | null;
  requestedPayload: Record<string, unknown>;
  decidedPayload: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
  steps: WorkflowStepDiagnostic[];
  events: Array<{
    stage: string; action: string; payload: Record<string, unknown> | null;
    comment: string; actor: string | null; occurredAt: string;
  }>;
  checks: Array<{ code: string; severity: "OK" | "WARNING" | "ERROR"; message: string }>;
}

export const loadWorkflowDiagnostics = (query: string) =>
  authenticatedFetch<WorkflowDiagnostic[]>(
    `/api/v1/workflow-diagnostics?q=${encodeURIComponent(query)}`
  );
